import cx from 'classnames'
import React from 'react'

import SVG from '@cinch/oxd-components/svg/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './list-item.module.css'

interface ListItemProps {
  className?: string
  bulletIcon?: React.ReactNode | React.ReactNodeArray | null
}

const ListItem: React.FC<ListItemProps> = ({ className = '', bulletIcon, children }) => (
  <div role="listitem" className={cx(styles.listItem, className, { [styles.listItemCustom]: !!bulletIcon })}>
    {!!bulletIcon && (
      <SVG
        width={tokens.customProperties.spacing.m}
        height={tokens.customProperties.spacing.m}
        className={styles.customBullet}
        hasGradient={true}
        children={bulletIcon}
      />
    )}
    {children}
  </div>
)

export default ListItem
